import React, { Component } from 'react';
import * as snackService from '../common/snack.service';
import * as queryService from '../common/query.service';
import history from '../../utils/history';
import { CONTRA_ENTRY_CREATE, CONTRA_ENTRY_DETAILS } from '../../data/enums/Route';
import tableConfig from './config';
import { CE_CONFIG } from '../common/domain.config';
import PageView from '../common/pagination/PageView';
import BillingSnackBar from '../../components/BillingMDC/BillingSnackbar';
import { checkIfApiCallSuccess, jvApi } from '../common/base.api';
import withBaseState from '../common/withBaseState';
import { voucherEncoder } from '../../utils/miscellaneous';
import ContraEntryStyled from './ContraEntryStyled';
import { TRANSACTION_TYPE } from '../../data/enums/enums';
import * as downloadService from '../common/download.service';
import {storeInLocalStorage ,fetchFromLocalStorage} from "../common/common";

const propTypes = {};
const defaultProps = {};

class ContraEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: {
        searchBox: false,
        filter: false,
      },
      snack: { ...snackService.snackParameters },
      queryParameters: {
        ...queryService.queryParameters,
      },
      data: {
        list: [],
        total: 0,
      },
    };

    const { downloadList } = this.props;

    this.basePaginationService = new queryService.QueryClass(
      this.setQueryParameters,
      this.getQueryParameters,
      this.loadTableData,
      downloadList,
    );
    this.basePaginationService.defaultResetFilter({
      ...queryService.queryParameters,
    });
  }

  componentDidMount() {
    this.getFilterStateFromStorage();
  }
  setFilterStateInStorage = () => {
    const { queryParameters} = this.state;
    
    storeInLocalStorage(
      'FILTER',
      {
       queryParameters,
      },
      "CONTRA_ENTRY"
    );
  };
  getFilterStateFromStorage = () => {
    const {queryParameters} =this.state;
    const localData = fetchFromLocalStorage('FILTER', "CONTRA_ENTRY");
    this.setState(
      { queryParameters:localData?.queryParameters || queryParameters ,},
      () => {
        this.loadTableData();
      },
    );
  };


  setQueryParameters = (queryParameters, callBack = () => null) => this.setState({ queryParameters }, callBack);

  getQueryParameters = () => {
    const { queryParameters } = this.state;
    return queryParameters;
  };

  /** get data for grid, adjust loading flag */
  loadTableData = () => {
    const { queryParameters } = this.state;
    const extraQuery = '&isContraEntry=true';
    this.setFilterStateInStorage();
    jvApi.getList(queryParameters, extraQuery).then(response => {
      if (checkIfApiCallSuccess(response)) {
        const { data } = this.state;
        data.list = response.list;
        data.total = response.total;
        this.setState({ data });
      }
    });
  };

  handleFabButtonClick = () => {
    history.push(`/${CONTRA_ENTRY_CREATE}`);
  };

  controlDisplay = (label, value) => {
    const { display } = this.state;
    display[label] = value;
    this.setState(display);
  };

  closeSnack = () => {
    const snack = snackService.resetSnack();
    this.setState({ snack });
  };

  handleTableBodyClick = id => {
    const voucherNumber = voucherEncoder(id) || '';
    history.push(`/${CONTRA_ENTRY_DETAILS}/${voucherNumber}`);
  };
  handleClearSearch =() =>{
    const {display}=this.state;
    this.setState({display:{...display,searchBox:false,search:false}});
    this.basePaginationService.clearSearchText();
  }
  handleDownloadClick = (type, label) => {
    const { queryParameters } = this.state;
    const { downloadList, detailDownloadList } = this.props;
    if (label === 'cn_details') {
      detailDownloadList({ type, query: {...queryParameters,filter: {
        jv_transaction_type: [TRANSACTION_TYPE.CONTRA_ENTRY],
      }} }).then(response => downloadService.resolver(response));
    } else {
      downloadList({ type, query: {...queryParameters,filter: {
        jv_transaction_type: [TRANSACTION_TYPE.CONTRA_ENTRY],
      }} }).then(response => downloadService.resolver(response));
    }
  };

  render() {
    const { display, queryParameters, data, snack } = this.state;

    const { serverResponseWaiting } = this.props;

    return (
      <ContraEntryStyled className="contra-entry">
        <PageView
          domainConfig={CE_CONFIG}
          headerConfig={{
            search: true,
            date: true,
            upload: false,
            download: true,
            filter: true,
            create: true,
          }}
          resetFilter={() =>
            this.basePaginationService.defaultResetFilter({
              ...queryService.queryParameters,
            })
          }
          controlDisplay={this.controlDisplay}
          serverResponseWaiting={serverResponseWaiting}
          handleDateRangeChange={this.basePaginationService.handleDateRangeChange}
          handleDownloadClick={this.handleDownloadClick}
          display={display}
          data={data}
          queryParameters={queryParameters}
          tableConfig={tableConfig}
          handleTableSorting={this.basePaginationService.handleTableSorting}
          onTableBodyClick={this.handleTableBodyClick}
          onPageSelect={this.basePaginationService.onPageSelect}
          handleFilterChange={this.basePaginationService.handleFilterChange}
          createHandler={this.handleFabButtonClick}
          handleSearchChange={this.basePaginationService.handleSearchInputChange}
          clearSearchText={this.handleClearSearch}
        />

        <BillingSnackBar closeSnack={this.closeSnack} config={snack} />
      </ContraEntryStyled>
    );
  }
}

ContraEntry.propTypes = propTypes;
ContraEntry.defaultProps = defaultProps;

const ContraEntryWithState = withBaseState(ContraEntry);

export default ContraEntryWithState;
